var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"template-padding",attrs:{"fill-height":"","column":""}},[_c('v-container',_vm._l((_vm.items),function(item,itemIndex){return _c('div',{key:itemIndex},[(item.type == 'banner' && itemIndex == 0)?[_c('v-container',{staticClass:"container-draw my-5"},[(_vm.pageType == 'Canvas')?_c('v-text-field',{attrs:{"label":"Image URL or Link","dense":"","outlined":""},model:{value:(item.image),callback:function ($$v) {_vm.$set(item, "image", $$v)},expression:"item.image"}}):_vm._e(),_c('v-img',{directives:[{name:"show",rawName:"v-show",value:(_vm.$vuetify.breakpoint.mdAndUp),expression:"$vuetify.breakpoint.mdAndUp"}],staticClass:"d-flex align-center",attrs:{"src":item.image}},[_c('div',{staticClass:"poppins ",class:_vm.bannerTextSize,staticStyle:{"color":"#a53a34","line-height":"80%","font-weight":"900"},attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(item.heading)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'heading' })}}}),_c('div',{staticClass:"poppins ",class:_vm.$vuetify.breakpoint.smAndUp ? 'h4' : 'h2',staticStyle:{"color":"#2d417c","line-height":"80%","font-weight":"900"},attrs:{"contenteditable":"true"},domProps:{"innerHTML":_vm._s(item.subtitle)},on:{"focusout":function($event){return _vm.editableData('banner', { element: 'subtitle' })}}})]),(_vm.pageType == 'Canvas')?_c('RowControls',{attrs:{"rowIndex":itemIndex}}):_vm._e()],1)]:_vm._e(),(item.type == 'grids')?[_c('Grid2',{attrs:{"item":item,"index":itemIndex,"styles":{
              settings: {
                colsImage: null
              },
              text: 'body poppins pa-4',
              image: {
								contain: true,
								wrapper: '',
								class: '',
								height: 'auto',
								width: 'auto',
								maxWidth: '100%',
								maxHeight: '',
								custom: {
									margin: '0 auto'
								}
							},
              heading1: {
                wrapper: 'd-flex justify-start cc-heading1 mb-5',
                classMobile: 'h5 poppins font-weight-bold',
                classLarge: 'h4 poppins font-weight-bold',
                after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
              },
              heading2: {
                wrapper:
                  'mb-5 cc-heading2 poppins font-weight-bold responsive-heading',
                classMobile: 'h5',
                classLarge: 'h4',
                after: '',
								guideWrapper: '',
								guideClass: 'ml-5'
              },
              textcard: {
                outlined: true,
                elevation: 0,
                card: 'text-center pa-5',
                text: 'h5 poppins',
                subtitle: '',
                custom: {},
              },
              imagecard: {
                doubleCard: false,
                elevation: 0,
                outlined: false,
                card: 'py-5 px-5',
                imagePosition: 'top',
                image: '',
                text:
                  'mb-5 card-header text-right h5 poppins font-weight-bold px-5',
                subtitle: 'body poppins font-weight-bold text-right pt-3 px-5',
                custom: {},
              },
              dialog: {
                elevation: 0,
                cardClass: 'py-5 px-5 my-5',
                cardColor: '',
                innerCard: '',
                dialogTitle: '',
                dialogName: 'rubik font-weight-bold hd1-dark-blue mt-3 mr-3 responsive-text',
                textWrapper: 'h5 body-poppins text-left responsive-text',
                custom: {
                  text: '',
                  textClass: 'mt-3',
                },
              },
            }}})]:_vm._e()],2)}),0),_c('ImageUploader',{on:{"uploadComplete":function($event){_vm.modals.image = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }